'use strict';
import React from 'react';
import NavBar from '../components/navBar';
import SideMenu from '../components/sideMenu';
import menuAction from '../actions/menuAction';
import Loading from '../components/loading';
import filterAction from '../actions/filterAction';
import filterStore from '../stores/filterStore';
import userSetAction from '../actions/userSetAction';
import userSetStore from '../stores/userSetStore';
import TeamModal from './userSetComponents/teamModal';
import TeamCreateModal from './userSetComponents/teamCreateModal';

class TeamSetting extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.handleMemberEdit = this.handleMemberEdit.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.shouldModalCloseTC = this.shouldModalCloseTC.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.state = {
            warningMsg: userSetStore.getState().warningMsg,
            processing: userSetStore.getState().processing,
            team: userSetStore.getState().team,
            removedTeam: userSetStore.getState().removedTeam,
            staffs: filterStore.getState().staffs,
            processingFilter: filterStore.getState().processing,
            iniLoadStaff: filterStore.getState().iniLoadStaff,

            modalClose: false,
            index: "",

            modalCloseTC: false,
            action: 0,
            title: "",
        };
    }

    componentDidMount() {
        menuAction.pageNumber(16);
        userSetStore.listen(this.onChange);
        filterStore.listen(this.onFilterChange);
        if (!this.state.processingFilter && !this.state.iniLoadStaff) {
            filterAction.processing(true);
            filterAction.getEmployee();
        }
        if (!this.state.processing) {
            userSetAction.processing(true);
            userSetAction.getTeam();
        }
        userSetAction.removedTeam([]);
    }
    componentWillUnmount() {
        userSetStore.unlisten(this.onChange);
        filterStore.unlisten(this.onFilterChange);
    }
    onFilterChange(state) {
        this.setState({
            staffs: state.staffs,
            processingFilter: state.processing,
            iniLoadStaff: state.iniLoadStaff,
        });
    }
    onChange(state) {
        this.setState({
            warningMsg: state.warningMsg,
            processing: state.processing,
            team: state.team,
            removedTeam: state.removedTeam,
        });
    }
    shouldModalClose(data) {
        this.setState({
            modalClose: data
        });
    }
    shouldModalCloseTC(data) {
        this.setState({
            modalCloseTC: data
        });
    }
    renderTeamMember(member) {
        return member.map((member, index) => {
            return (
                <div className="tm-mb" key={index}>
                    {(index + 1) + ". " + member.userName}
                </div>
            );
        })
    }
    handleEdit(e) {
        //0 is create
        //1 is remove
        let action = parseInt(e.currentTarget.getAttribute("data-action"));
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        let title;
        if (action == 0) {
            title = "Create New Team";
        } else {
            title = "Remove Team";
        }
        this.setState({
            title: title,
            action: action,
            index: index,
            modalCloseTC: true
        });

    }
    handleSave(e) {
        if (this.state.processing) return;

        userSetAction.processing(true);
        userSetAction.updateTeam(this.state.team, this.state.removedTeam);
    }
    handleMemberEdit(e) {
        let index = parseInt(e.currentTarget.getAttribute('data-index'));
        this.setState({ index: index, modalClose: true });
    }

    renderDetail(team, index) {
        return (
            <div className="col-sm-3" key={index}>
                <div className="tm">
                    <div className="tm-btn-grp">
                        <button className="btn btn-default btn-xs" data-index={index}
                            onClick={this.handleMemberEdit}>Edit Team</button>
                        <button className="btn btn-warning btn-xs" data-index={index} data-action="1"
                            onClick={this.handleEdit}>Remove Team</button>
                    </div>
                    <div className="tm-nm">
                        <b>{team.teamName}</b>
                    </div>

                    {this.renderTeamMember(team.teamMember)}
                </div>
            </div>
        );
    }
    renderRow(i) {
        let detailContent = [];
        for (let j = 0; j < 4; j++) {
            if (j + i * 4 < this.state.team.length) {
                detailContent = detailContent.concat(
                    this.renderDetail(this.state.team[j + i * 4], j + i * 4)
                );
            } else {
                break;
            }
        }
        return detailContent;
    }
    renderTeam() {
        let teamContent = [];

        for (let i = 0; i < Math.ceil(this.state.team.length / 4); i++) {
            teamContent = teamContent.concat(
                <div className="row" key={i}>
                    {this.renderRow(i)}
                </div>
            )
        }
        return teamContent;

    }
    render() {
        let modal = "", modal2 = "";
        if (this.state.modalClose) {
            modal = (
                <TeamModal
                    modalClose={this.state.modalClose}
                    shouldModalClose={this.shouldModalClose}
                    team={this.state.team}
                    index={this.state.index}
                    staffs={this.state.staffs}
                />
            );
        }
        if (this.state.modalCloseTC) {
            modal2 = (
                <TeamCreateModal
                    modalClose={this.state.modalCloseTC}
                    shouldModalClose={this.shouldModalCloseTC}
                    title={this.state.title}
                    team={this.state.team}
                    removedTeam={this.state.removedTeam}
                    action={this.state.action}
                    index={this.state.index}
                />
            )
        }
        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <div className=" col-md-10  col-sm-8 us-form">
                        <h4><b>Team Management</b></h4>
                        <div className="row">
                            <div className="col-sm-12">

                                <button className="btn btn-default" onClick={this.handleEdit} data-action="0" data-index="">
                                    Create Team
                                    </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="tm-wp">
                                    {this.renderTeam()}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <button className="btn btn-default" onClick={this.handleSave}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                    {modal}
                    {modal2}
                </div>

                <Loading processing={this.state.processing || this.state.processingFilter} />
            </div>
        );
    }
}

export default TeamSetting;


// WEBPACK FOOTER //
// ./app/setComponents/teamSetting.js